/** *
 * The list of valid entityTypes. You can create this list using the query below...
 *
 * select 'export const ' || upper('entity_' || replace(replace(name, ' ', '_'), '/', '_')) || ' = ''' || upper(shortname) || ''';' from observation.entitytype where not deleted;
 */

/** *
on DASHBOARD load 4 API calls to notecounts by entitytype = PCPF, MFST, MM, PCPPv2
when do you need to see those notes?
-> when printing : medication ,manifest, visit frequency, care plan problems
-> on the widget : care plan problems

From individuals widget,  endpoint calls to get the note content when printing
 */
export const ENTITY_MEDICATION = 'MM';
export const ENTITY_PATIENT_CARE_PLAN_FREQUENCY = 'PCPF';
export const ENTITY_PATIENT_CARE_PLAN_FREQUENCY_ORDER = 'CPF';
export const ENTITY_PATIENT_CARE_PLAN_PROBLEM_V2 = 'PCPPv2';
export const ENTITY_PATIENT_CARE_PLAN_PROBLEM_TASK = 'PCPPT';
export const ENTITY_PATIENT_CARE_GIVER = 'CG';
export const ENTITY_MANIFEST = 'MFST';
export const ENTITY_PATIENT_MEASURE = 'MEAS';
export const ENTITY_ADMIT = 'ADM';
export const ENTITY_DISCHARGE = 'DIS';
export const ENTITY_LOC = 'LOC';
export const ENTITY_PSO = 'PSO';
export const ENTITY_MEDICATION_ORDER = 'MMD';
export const ENTITY_FACILITY_CHANGE = 'FC';
export const ENTITY_GENERAL_ORDER = 'OTH';
/**
 * Order types eligible for Orders Log addendum badge / guards.
 */

export const ORDER_NOTE_ENTITY_TYPES = [ENTITY_ADMIT, ENTITY_DISCHARGE, ENTITY_LOC, ENTITY_PSO, ENTITY_MEDICATION_ORDER, ENTITY_FACILITY_CHANGE, ENTITY_PATIENT_CARE_PLAN_FREQUENCY_ORDER, ENTITY_GENERAL_ORDER];
export const REFRESH_PN = 'PNC.REFRESH_PN';
export const REFRESH_ICON = 'PNC.REFRESH_ICON';